import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function authHeaders() {
  const token = localStorage.getItem("hg_admin_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function track(event, data = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
}

export const WHATSAPP_URL = `https://wa.me/919936706961?text=${encodeURIComponent(
  "Hello Harwell Global Education, I am interested in studying in Europe and would like counselling regarding Bachelor's/Master's programs."
)}`;

export function scrollToSection(hash) {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -100 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}
